import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import NestHome from 'Component/common/nest-home';

interface TemplateProps {}

const Template: FC<TemplateProps> = memo((props) => {
    return <NestHome {...props} />;
});

class TemplateClass extends React.Component {
    render(): React.ReactNode {
        return <Template {...this.props} />;
    }
}

export default Udesk.react.udeskify(TemplateClass);
